import {
    buildProfileCabinetOnboardingStorageKey,
} from "../../application/user-profile/profile-cabinet-onboarding";

const SEEN_VALUE = "seen";

function getStorage() {
    if (
        typeof window === "undefined" ||
        !window.localStorage
    ) {
        return null;
    }

    return window.localStorage;
}

export const browserProfileOnboardingStore = {
    hasSeenCabinetLocation(userId) {
        const storageKey =
            buildProfileCabinetOnboardingStorageKey(
                userId
            );

        if (!storageKey) {
            return true;
        }

        try {
            const storage = getStorage();

            if (!storage) {
                return true;
            }

            return (
                storage.getItem(storageKey) ===
                SEEN_VALUE
            );
        } catch {
            return true;
        }
    },

    markCabinetLocationSeen(userId) {
        const storageKey =
            buildProfileCabinetOnboardingStorageKey(
                userId
            );

        if (!storageKey) {
            return;
        }

        try {
            const storage = getStorage();

            if (!storage) {
                return;
            }

            storage.setItem(
                storageKey,
                SEEN_VALUE
            );
        } catch {
            return;
        }
    },
};
